import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.js';
import { themeVars } from '@synoptic/ui-kit/theme/vars.js';
import { borderRadius, space } from '@synoptic/ui-kit/tokens.js';
import { style } from '@vanilla-extract/css';

export const ctWrappedContainer = style([
  {
    padding: space.s16,
    backgroundColor: '#F5F4FD',
  },
  responsiveStyle({
    mobile: {
      padding: 0,
    },
    laptop: {
      padding: space.s16,
    },
  }),
]);

export const ctWrapped = style([
  {
    borderRadius: borderRadius.r24,
    backgroundColor: '#050110',
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
    backgroundImage: 'url(./container.jpg)',
    backgroundSize: 'cover',
    backgroundPosition: 'top center',
    maxWidth: 1920,
    margin: '0 auto',
  },
  responsiveStyle({
    mobile: {
      borderRadius: 0,
      padding: space.s24,
      overflowY: 'auto',
    },
    tablet: {
      overflowY: 'unset',
    },
    laptop: {
      borderRadius: borderRadius.r24,
      padding: `${space.s32}px ${space.s64}px`,
    },
  }),
]);

export const ctWrappedHeader = style([
  {
    height: 72,
    width: '100%',
    borderRadius: borderRadius.r16,
    backgroundColor: 'rgba(255, 255, 255, 0.02)',
    border: `1px solid rgba(221, 212, 245, 0.2)`,
    backdropFilter: 'blur(27.5px)',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: space.s8,
    color: themeVars.container.foreground.primary,
  },
  responsiveStyle({
    mobile: {
      padding: `${space.s16}px ${space.s24}px`,
    },
    laptop: {
      padding: `${space.s16}px 40px`,
    },
  }),
]);

export const ctWrappedStars = style({
  maxWidth: 'calc(100% - 64px)',
  position: 'absolute',
  top: 10,
  pointerEvents: 'none',
});

export const ctWrappedSearchByUsernameButton = style({
  selectors: {
    '&:is(&)': {
      color: themeVars.container.foreground.primary,
    },
    '&.active': {
      display: 'none',
    },
  },
});
